import React from "react";

import { CONTACT_LINK_BATMAID } from "@config/links";

import { MODALS } from "@typings/modals";
import { AVAILABLE_LANGS } from "@typings/globals";

import { Button } from "@components/General/Button";

import { Dialog } from "@ui/Molecules";

import { DialogManager } from "@features/DialogManager";

import { useTranslate } from "@hooks/useTranslate";

export const FullyBookedModal: React.FC<{ language: AVAILABLE_LANGS }> = ({
  language,
}) => {
  const { hideDialog } = DialogManager.useManager();
  const translate = useTranslate("batmaid_pwa_end_of_tenancy");

  const contactHref = `/${language}${CONTACT_LINK_BATMAID}`;

  return (
    <DialogManager.Dialog
      id={MODALS.EOT_FULLY_BOOKED}
      data={{
        variant: "blank",
      }}
      direction="vertical"
      size="sm"
      onRequestClose={hideDialog}
    >
      <Dialog.Title>{translate("fully_booked_modal_title")}</Dialog.Title>

      <Dialog.Content>
        <Dialog.Paragraph>
          {translate("fully_booked_modal_paragraph_1")}
        </Dialog.Paragraph>
        <Dialog.Paragraph>
          {translate("fully_booked_modal_paragraph_2")}
        </Dialog.Paragraph>
      </Dialog.Content>

      <Dialog.Actions>
        <Button
          variantStyle="fill"
          colorType="blue"
          size="large"
          onClick={() => {
            window.location.href = contactHref;
          }}
        >
          {translate("fully_booked_modal_cta")}
        </Button>
      </Dialog.Actions>
    </DialogManager.Dialog>
  );
};
